<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>书记信箱</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 操作 -->
    <el-row style="margin: 10px 0 10px 0;float: right;">
      <el-button @click="deleteLogs" size="small" type="danger" icon="el-icon-delete">删 除</el-button>
    </el-row>
    <!--列表-->
    <el-table ref="multipleTable" @selection-change="handleSelectionChange" size="small" :data="list" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="55">
      </el-table-column>
      <el-table-column align="center" prop="username" label="姓名" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="tel" label="电话" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="content" label="内容" width="300">
      </el-table-column>
      <el-table-column prop="hf_content" label="回复内容"  width="300">
      </el-table-column>
      <el-table-column sortable prop="create_time" label="时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="160">
        <template slot-scope="scope">

            <el-button v-if="scope.row.hf_status == 0" size="mini" type="danger" @click="huifu(scope.row)">回复</el-button>
            <el-button v-else size="mini" type="success" >已经回复</el-button>

        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :visible.sync="refundVisible" width="750px">
      <el-form>
      <!-- <div class="yl">


            <div class="tjnr">{{usernr.content}}</div>

       </div> -->

      <div class="glhf">
        <div class="glytj">

           <textarea v-model="huifu_content" class="glytj_txt"></textarea>
        </div>
      </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="qdhf" class="a3">确定回复</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import { getEmails,delEmails ,hfly} from '../../api/baseset.js'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        list: [],
         refundVisible: false,
        formInline: {
          page: 1,
          limit: 10
        },
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        multipleSelection: [],
        ids: ''
      }
    },
    created() {
      this.getList(this.formInline)
    },
    components: {
      Pagination
    },
    methods: {
      getList() {
        let that = this;
        getEmails({messageType: 2}).then(res => {
          if(res.code == 0){
            that.list = res.data;
          }
        })
      },
      deleteLogs(){
        this.$confirm('您确定要删除此信息吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          let data = {ids:this.ids}
          delEmails(data).then(res => {
            this.loading = false
            if(res.code == 0){
              this.getList(this.formInline)
              this.$message({
                type: 'success',
                message: res.msg
              })
            }else{
              this.$message.error(res.msg)
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('数据加载失败，请稍后再试！')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      handleSelectionChange(arr) {
        this.multipleSelection = arr;
        let str = '';
        arr.forEach(function(v){
          str += v.id+','
        })
        this.ids = str.substr(0,str.length-1);
      },
      huifu(row){
        console.log(row)
        this.usernr = row;
        this.refundVisible = true;
      },
      qdhf(){
        var data ={id:this.usernr.id,hf_content:this.huifu_content}
        hfly(data).then(res => {
          this.loading = false
          if(res.code == 0){
            this.getList(this.formInline)
            this.$message({
              type: 'success',
              message: res.msg
            })
             this.huifu_content = '';
             this.refundVisible = false
          }else{
            this.$message.error(res.msg)
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('数据加载失败，请稍后再试！')
        })
      }
    }
  }
</script>

<style>
  .a3{
    background-color: #0083FD;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/views/investigation/sjxx.vue